export const PORTRAIT_WIDTH = 1080;
export const PORTRAIT_HEIGHT = 1920;

/** Unitless scale: 1 at 1080×1920, shrinks to fit the given box. */
export function computePortraitScale(width, height) {
  if (!width || !height) return 1;
  return Math.min(width / PORTRAIT_WIDTH, height / PORTRAIT_HEIGHT);
}

/** Keep --s on :root so portaled modals inherit a valid scale. */
export function setRootPortraitScale(scale) {
  if (typeof document === 'undefined') return;
  document.documentElement.style.setProperty('--s', String(scale));
}
